import React from 'react';
import { Radar } from 'react-chartjs-2';

const EmotionalAnalytics = () => {
  // Define your chart data and options
  const data = {
    labels: ['Trust', 'Joy', 'Calm', 'Frustration', 'Angry','Energy'],
    datasets: [
      {
        label: 'Agent',
        data: [12, 19, 13, 11, 4,9],
        backgroundColor: '#029CD46f',
        borderColor: '#029CD4ff',
        borderWidth: 1,
        pointBackgroundColor: '#029CD46f',
      },
      {
        label: 'Customer',
        data: [2, 9, 3, 1, 14,19],
        backgroundColor: '#0052D96f',
        borderColor: '#0052D99f',
        borderWidth: 1,
        pointBackgroundColor: '#0052D96f',
      }
    ],
  };

  const options = {
    scale: {
      ticks: { beginAtZero: true },
    },
  };


  return (
    
    <div className='chartArea'>
    {/* <h2>My Radar Chart</h2> */}
    <div  >
      <Radar data={data} options={options} style={{ maxWidth: '100%', margin: '0 auto',maxHeight:'400px'}}/>
    </div>
  </div>
  )
}

export default EmotionalAnalytics